import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Y si mi caso ya es crónico?',
  a: 'La mayoría de nuestros usuarios llegaron después de años de dolor "crónico". Lo que descubrieron es que era una atrofia no tratada. Si tu pie siente dolor, tiene capacidad de respuesta. Eso es todo lo que necesitamos.'
}, {
  q: '¿Necesito equipamiento o gimnasio?',
  a: 'Cero. Todo se hace descalzo, en el piso de tu casa, en 15 minutos. Solo necesitás una superficie plana.'
}, {
  q: '¿Cuánto tiempo hasta ver resultados?',
  a: 'Entre el día 5 y 10 de la Fase 1 notás diferencia en el primer paso de la mañana. Resultados permanentes llegan en la Fase 3 (día 21-30).'
}, {
  q: '¿Por qué $19.900 si hay videos gratis en YouTube?',
  a: 'YouTube te da ejercicios sueltos sin progresión. Este es el sistema completo, en orden, con la lógica detrás de cada paso. La diferencia entre alivio temporal y solución permanente.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Confiamos tanto en el protocolo que ofrecemos 7 días de garantía. Si aplicás la Fase 1 completa y no notás cambio en el primer paso de la mañana, te devolvemos el dinero. Sin vueltas.'
}];
function FaqItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="border border-dark-border rounded-lg overflow-hidden bg-dark-card" data-id="element-65">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left hover:bg-dark transition-colors" data-id="element-66">
        <span className="font-bold text-white text-base md:text-lg" data-id="element-67">
          ❓ {q}
        </span>
        <motion.div animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="shrink-0" data-id="element-68">
          <ChevronDownIcon className="w-4 h-4 text-white/50" data-id="element-69" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-70">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="overflow-hidden" data-id="element-71">
            <div className="px-4 pb-3 text-white text-base md:text-lg leading-relaxed border-t border-dark-border pt-3" data-id="element-72">
              {a}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FaqSection() {
  return <section className="py-6 md:py-10 px-4 bg-dark-card" data-id="element-73">
      <div className="max-w-3xl mx-auto" data-id="element-74">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl font-black uppercase text-white text-center mb-4" data-id="element-75">
          Preguntas Frecuentes
        </motion.h2>
        <div className="space-y-2" data-id="element-76">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} data-id="element-77">
              <FaqItem q={faq.q} a={faq.a} data-id="element-78" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}